import React from 'react'
import {Box, Dialog as DialogUI, DialogActions, DialogContent, DialogTitle} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import IconCloseButton from './button/IconCloseButton';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Loading from "./Loading";

const useStyle = makeStyles(theme => ({
	root: {
		position: 'relative'
	},
	content: {
		minHeight: 50
	},
	centered: {
		textAlign: 'center'
	},
	border: {
		border: theme.palette.border.onlyContrast ? `1px solid ${theme.palette.border.onlyContrast}` : undefined,
	},
	closeButtonBox: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
	},
	closeButton: {
		color: theme.palette.primary.main,
	},
	loading: {
		width: '92%'
	}
}));

function Dialog({
	title,
	children,
	fullWidth = true,
	maxWidth,
	open,
	className,
	contentClassName,
	titleCentered = false,
	transitionDuration,
	onClose,
	paperClassName,
	dialogActions,
	loading,
	htmlId
}) {
	const classes = useStyle();
	return (
		<DialogUI
			fullWidth={fullWidth}
			maxWidth={maxWidth}
			className={clsx(
				className,
				classes.root
			)}
			transitionDuration={transitionDuration}
			open={open}
			PaperProps={{
				className: clsx(paperClassName, classes.border)
			}}
			id={htmlId}
		>
			{title &&
				<DialogTitle className={clsx(
					classes.title, {
						[classes.centered]: titleCentered
					}
				)}>{title}
					{onClose ? (
						<Box className={classes.closeButtonBox}>
							<IconCloseButton
								aria-label="close"
								className={classes.closeButton}
								onClick={onClose}
							/>
						</Box>
					) : null}
				</DialogTitle>
			}
			<DialogContent className={clsx(
				classes.content,
				contentClassName
			)}>
				{
					!!loading ?
						<Loading className={classes.loading}/>
						:
						children
				}
			</DialogContent>
			<DialogActions children={dialogActions}/>
		</DialogUI>
	)
}

Dialog.propTypes = {
	classes: PropTypes.any,
	maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
}

export default Dialog;